<tec-create-layout [formGroup]="form">
    @if (showError) {
        <tec-alert [hiddenCloseButton]="true" [msg]="showError" [status]="'error'" (closeAlert)="showError = ''" />
    }

    @if (hasThemeEditor) {
        <tec-item
            [size]="'lg'"
            [tagImage]="{ icon: 'icon-customize', status: 'default' }"
            [title]="form.value.title"
        >
            <tec-tag [status]="'default'">
                {{ (selectedSkin === 'dark' ? 'DESIGN.THEMES.DARK' : 'DESIGN.THEMES.LIGHT') | translate }}
            </tec-tag>
            @if (companyLabel) {
                <tec-list-detail>
                    <span>{{ companyLabel }}</span>
                </tec-list-detail>
            }
        </tec-item>
    }

    @if (currentThemeControl; as themeControl) {
        <app-design-theme-detail [formControl]="themeControl" [themeMode]="selectedSkin" />
    }

    @if (hasThemeEditor) {
        <tec-footer-actions>
            <tec-button [label]="'BUTTON.EXIT' | translate" [type]="'secondary'" (clickEvent)="cancel()" />
            <tec-button [label]="'BUTTON.SAVE' | translate" (clickEvent)="save()" />
        </tec-footer-actions>
    }
</tec-create-layout>

@if (showModalDesignTheme) {
    <app-modal-design-theme (closeEvent)="closeModalDesignTheme($event)" />
}
@if (showModalCancelDesign) {
    <app-modal-cancel-design [isVisible]="true" (closeEvent)="closeModalCancelDesign($event)" />
}
